import React, { useEffect,  useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import {  useNavigate } from 'react-router-dom'
import config, { axiosInstance } from '../Config'
import RolesTable from './RolesTable'
import Loader from '../Loader'
import swal from 'sweetalert'
import { usePermissionData } from '../../AppContext'
import secureLocalStorage from 'react-secure-storage'

const RolesIndex = () => {

    const [data, setData] = useState([])
    const [roles, setRoles] = useState([])
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(false)

    const users = secureLocalStorage.getItem("admin_credentials");

    useEffect(() => {
        window.scrollTo(0, 0);
        getRolesData();
    }, [])

    useEffect(() => {
        document.title = "Roles & Permission | Mindora"
    }, [])

    function getRolesData() {
        setLoading(true)
        axiosInstance.get('roles', {
            headers: { Authorization: `Bearer ${users?.token}` }
        })
            .then(res => {
                const list = res.data?.data ?? res.data ?? []
                setData(list)
                setRoles(list)
            })
            .catch(err => {
                console.log(err)
                swal('', 'Failed to load roles.', 'error')
            })
            .finally(() => setLoading(false))
    }

    const navigate = useNavigate()

    // roles and permissions
    const { checkAccess } = usePermissionData()

    const [items_perpage, setItemsPerPage] = useState(10)

    const total_pages = Math.ceil(data?.length / items_perpage);

    const final_data = data?.slice(page * items_perpage - items_perpage, page * items_perpage)

    const changePage = (pagecount) => {
        if (pagecount > 0 && pagecount <= total_pages) {
            setPage(pagecount)
            window.scrollTo(0, 0)
        }
    }

    const filterByName = (e) => {
        if (page !== 1)
            setPage(1)
        const filteredData = roles.filter((role) =>
            role.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
        setData(filteredData)
    }

    const onDelete = (role_id) => {
        swal({
            title: "Are you sure?",
            text: "You Want to Delete the Role.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setLoading(true)
                    axiosInstance.delete(`roles/${role_id}`, {
                        headers: { Authorization: `Bearer ${users?.token}` }
                    })
                        .then(() => {
                            swal("", "Role Deleted Successfully", "success")
                            const updatedData = data.filter(item => item.id !== role_id)
                            setData(updatedData)
                            setRoles(prev => prev.filter(item => item.id !== role_id))
                        })
                        .catch((error) => {
                            console.log(error)
                            swal("", error?.response?.data?.message || "Something Went Wrong!", "error")
                        })
                        .finally(() => setLoading(false))
                }
            });
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Roles & Permission" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                                <div className='d-md-flex justify-content-between align-items-start mb-4'>
                                    <div className="ps-section__search  d-flex justify-content-end mb-4">
                                        <div
                                            className="ps-form--search-simple"
                                        >
                                            <input
                                                className="form-control bg-white"
                                                type="text"
                                                placeholder="Search Roles.."
                                                onChange={filterByName}
                                            />
                                            <button type='button'style={{right: '30px' }}>
                                                <i className="icon icon-magnifier"></i>
                                            </button>
                                        </div>

                                        <select className='form-select ms-3 fs-5'
                                            value={items_perpage}
                                            onChange={(e) => {
                                                if (page !== 1)
                                                    setPage(1)
                                                setItemsPerPage(e.target.value)
                                            }}
                                            style={{ width: '110px', height: '45px', borderRadius: '8px' }}>
                                            <option value="5">Show 5</option>
                                            <option value="10">Show 10</option>
                                            <option value="20">Show 20</option>
                                            <option value="30">Show 30</option>
                                        </select>
                                    </div>
                                    <div className='text-center'>
                                        {
                                            checkAccess(7, 2) &&
                                            <button type="button" onClick={() => navigate(`${config.appUrl}add-role`)} className="button  btn-green  color-white">
                                                <i className='icon-plus me-3 fs-5'></i>
                                                Add Role</button>
                                        }
                                        <button type="button" onClick={() => navigate(-1)}
                                            className="button ms-3"
                                            style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}>
                                            <i className='icon-arrow-left me-2'></i>
                                            Back</button>
                                    </div>

                                </div>

                                {/* Listview  */}
                                <RolesTable
                                    data={final_data}
                                    onDelete={onDelete}
                                    checkAccess={checkAccess}
                                />

                                <div className='d-flex flex-column align-items-end mt-5'>
                                    <p className='mb-4'>Show {final_data?.length} of {data?.length} items.</p>
                                    <div className='d-flex justify-content-md-start justify-content-center flex-wrap'>

                                        <div className={`bd-number-pagination rounded-2 me-3 mt-2`}
                                            onClick={() => changePage(page - 1)}>
                                            <i className='icon-arrow-left'></i>
                                        </div>

                                        {
                                            [...Array(total_pages)].map((_, pagecount) => {
                                                pagecount += 1
                                                return (
                                                        <div key={pagecount} className={`bd-number-pagination rounded-2 mx-1 mt-2 pe-1 ${page === pagecount && 'activepage'}`} onClick={() => changePage(pagecount)}>
                                                            {pagecount < 10 ? ('0' + pagecount) : pagecount}
                                                        </div>
                                                )
                                            })
                                        }

                                        <div className={`bd-number-pagination rounded-2 ms-3 mt-2`}
                                            onClick={() => changePage(page + 1)}>
                                            <i className='icon-arrow-right'></i>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default RolesIndex
